// extracted by mini-css-extract-plugin
module.exports = {"container":"AddonButton_container__3_3Wa","addonName":"AddonButton_addonName__2vl8X","icon":"AddonButton_icon__sWw5j"};